import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import Menu from "../layout/doctorLeftmenu"
import { Link } from "react-router-dom";
import { storage, storyCategoryRef } from "../firebase";
import moment from 'moment';
import { db, database, storyRef} from '../firebase'
import $ from 'jquery';
import ContentTextEditor from './newStoriesEditor'

export default class NewStories extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name:"",
            status:"",
            mainCategory:"",
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleMainCategoryChange = this.handleMainCategoryChange.bind(this);
        this.validateSubmission = this.validateSubmission.bind(this);
        this.updateValidateSubmission = this.updateValidateSubmission.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
        const url = new URL(window.location.href);
        let url_path = window.location.href.split("=");
        let keyId = (url_path[1]);
        this.renderList(keyId)

    }
    async renderList(keyId) {
        
        let dataList = []
        let id = keyId;
        const ref = id ? '/storyCategory/' + id : 'storyCategory'
        const userRef = database.ref(ref)
        const valueRef = id ? userRef : await userRef.orderByChild('key').equalTo('value')
        const snapshot = await valueRef.once('value')
        const val = snapshot.val()
        if (val) {
            $("#name").val(val.name)
            $("#status").val(val.status)
            $("#mainCategory").val(val.mainCategory)
            this.setState({
                id: id,
                name: val.name,
                status: val.status,
                mainCategory:val.mainCategory,

            })
        }
    }
    updateValidateSubmission = (url) => {
        let newDate = moment(new Date()).format("DD/MM/YYYY")
        const item = {
            name: this.state.name,
            mainCategory:this.state.mainCategory,
            status: this.state.status,
            createdAt: newDate

        }
        database.ref(`storyCategory/${this.state.id}`).update(item).then(() => {
            alert("Updated Successfully")
            window.location.href = "/storyCategory"
             this.renderList();
           
        }).catch(() => {
            alert("Somthing went wrong")
        })
    }
    validateSubmission = () => {
        
        if (this.state.name === '') {
            alert('Enter name')
        }
        else if (this.state.mainCategory === '') {
            alert('Select category')
        }
        else if (this.state.status === '') {
            alert('Select status')
        }
        else {
            
            if (this.state.id == null) {
                    this.handleSubmit("");
                }
                else {
                    this.updateValidateSubmission("");
                }
            
        }
    }
    handleSubmit = (url) => {
        let newDate = moment(new Date()).format("DD/MM/YYYY")
        const item = {
            name: this.state.name,
            mainCategory:this.state.mainCategory,
            status: this.state.status,
            createdAt: newDate
        }
        storyCategoryRef.push(item).then(() => {
            alert("Saved Successfully")
            window.location.href = "/storyCategory"
        }).catch(() => {
            alert("Somthing went wrong")
        })
    }
    handleStatusChange = (e) => {
        this.setState({
            status: e.target.value
        })
    }
    handleMainCategoryChange = (e) => {
        this.setState({
            mainCategory: e.target.value
        })
    }
    handleChange = (e) => {
        this.setState({
            name: e.target.value,
        });
    };
    render() {
        return (
            <div className="main-wrapper">
                <Header></Header>
                <div className="main-content">
                    <Menu></Menu>
                    <div className="content-right-wrapper">
                        <div className="container">
                            <form className='form-wrapper'>
                                <ul className="breadcrumb">
                                    <li><a href="/dashboard">Dashboard</a></li>
                                    <li><a href="/storyCategory">Story Category</a></li>
                                    <li>New Story Category</li>
                                </ul>
                                <div className='form-head'>Story Category</div>
                                <div className="form-group">
                                    <label for="name">Name</label>
                                    <input type="text" className="form-control" name="name" onChange={this.handleChange}
                                        id="name"
                                    />
                                </div>
                                <div className="form-group">
                                    <label for="storyCategory">Main Category</label>
                                    <select className="form-control" onChange={this.handleMainCategoryChange} id="mainCategory" name="mainCategory">
                                        <option value="">Select</option>
                                        <option value="Course Reviews">Course Reviews</option>
                                        <option value="Stories">Stories</option>
                                        <option value="Blogs">Blogs</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label for="storyStatus"> Status</label>
                                    <select className="form-control" onChange={this.handleStatusChange} id="status" name="status">
                                        <option value="">Select</option>
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </select>
                                </div>
                                <div className="form-group mt-4">
                                    <Link to="/storyCategory">
                                        <button type="button" className="btn btn-primary" style={{ float:"right",marginLeft: "10px" }}>Cancel</button>
                                    </Link>
                                    {this.state.id == null ?
                                        <button type="button" className="btn btn-primary" style={{ float:"right" }} onClick={this.validateSubmission}>Submit</button>
                                        :
                                        <button type="button" className="btn btn-primary" style={{ float: "right" }} onClick={this.validateSubmission}>Update</button>
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <Footer></Footer>
            </div>
        )
    }

}
const styles = {
    editor: {
        border: '1px solid gray',
        minHeight: '6em'
    }
};


// WEBPACK FOOTER //
// ./src/admin/newStoryCategory.jsx